import StepsAdvanced2 from "./StepsAdvanced2";

export default function Level_Advanced2({steps, setSteps}) {
  return (
    <section>
      <div className="level-title">Advanced 2</div>
      <br />
      <StepsAdvanced2 steps={steps} setSteps={setSteps}/>
    </section>
  )
}